import React, { useEffect, useState, Fragment } from "react";
import Card from "@mui/material/Card";
import {
  CardContent,
  CircularProgress,
  IconButton,
  ListItem,
  TextField,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { CSDataTableColumns } from "../../modal/CSDataTable";
import CSDataTable from "../../components/CSDataTable";
import { useNavigate } from "react-router-dom";
import DialogBoxUploadFiles from "./component/DialogBoxRiskAssesment/DialogBoxRiskAssesmentUploadFiles";
import DialogBoxComponent from "../../components/DialogBoxComponent";
import {
  fetchCyberSecurityRiskAssessmentList,
  deleteCyberSecurityRiskAssessment,
  deleteMultipleCyberSecurityRiskAssessment,
  fetchSupplyChainRiskAssessmentList,
  deleteSupplyChainRiskAssessment,
  deleteMultipleSupplyChainRiskAssessment,
  downloadTemplates,
  createMultipleSupplyChainRiskAssessment,
  fetchCyberSecurityRiskAssessmentById,
  downloadCyberSecurityRiskAssessment,
} from "./helper";
import { useUserContext } from "../../context/auth/UserContext";
import { useRiskAssessmentContext } from "../../context/RiskAssessment/RiskAssessmentContext";
import { exportExcel, exportExcelSupplyChain } from "./utils";
import { supplyChainRiskAssesment } from "./modal";
import * as XLSX from "xlsx";
import { CSImport } from "./component/DialogBoxRiskAssesment/CSImport";
import { useAccessRights } from "../../utils/useAccessRights";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2, pb: 1 }}>{children}</Box>}
    </div>
  );
}

export const RiskAssesment = () => {
  const riskAssesment_CS_Access = useAccessRights("Risk Assessment - CS");
  const riskAssesment_SC_Access = useAccessRights("Risk Assessment - SC");

  //Menu option
  const optionsTab1 = ["Control", "Threat Source", "Vulnerabilities", "Delete"];
  const optionsTab2 = ["Download Template", "Upload Assessment", "Delete"];

  const columns: CSDataTableColumns[] = [
    {
      accessorKey: "threatSourceName",
      header: "Threat Source",
      size: "180px",
    },
    {
      accessorKey: "likelihoodName",
      header: "Likelihood",
      size: "80px",
    },
    {
      accessorKey: "adverseImpactName",
      header: "Adverse Impact ",
      size: "80px",
    },
    {
      accessorKey: "inherentRiskName",
      header: "Inherent Risk",
      size: "80px",
    },
    {
      accessorKey: "residualRiskName",
      header: "Residual Risk",
      size: "80px",
    },
    {
      accessorKey: "responseName",
      header: "Risk Response",
      size: "80px",
    },
    {
      accessorKey: "comment",
      header: "Comments",
      size: "100px",
    },
    {
      accessorKey: "edit",
      header: "",
      size: "30px",
      isEditable: riskAssesment_CS_Access?.isUpdate,
    },
    {
      accessorKey: "delete",
      header: "",
      size: "30px",
      isDeletable: riskAssesment_CS_Access?.isDelete,
    },
  ];
  const columns2: CSDataTableColumns[] = [
    {
      accessorKey: "supplierName",
      header: "Suppiler Name",
      size: "200",
    },
    {
      accessorKey: "supplierProduct",
      header: "Suppiler Product",
      size: "200",
    },
    {
      accessorKey: "supplierService",
      header: "Supplier Service",
      size: "200",
    },
    {
      accessorKey: "criticalProcessesDependency",

      header:
        "Critical Process Reliance? ",

      size: "150",
    },
    {
      accessorKey: "confidentialDataAccess",

      header: "Confidential Data Access?",

      size: "150",
    },
    {
      accessorKey: "supplierRiskLevel",
      header: "Supplier Risk Level",
      size: "30",
    },
    {
      accessorKey: "edit",
      header: "",
      size: "30",
      isEditable: riskAssesment_SC_Access?.isUpdate,
    },
    {
      accessorKey: "delete",
      header: "",
      size: "30",
      isDeletable: riskAssesment_SC_Access?.isDelete,
    },
  ];

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openCsImport, setOpenCsImport] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [previewRecord, setPreviewRecord] = useState({});
  const [originalList, setOriginalList] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [uploadRiskList, setUploadRiskList] = useState<any[]>([])
  const [uploadRiskDupList, setUploadRiskDupList] = useState<any[]>([])
  const [dialogUploadFiles, setDialogUploadFiles] = useState({
    openDialog: false,
  });
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openImportInfo: false,
    openSuccessDialogBox: false,
    openUploadAssessmentDialog: false,
  });

  const { userId, companyProfileID } = useUserContext();
  const {
    setSelectedRiskAssessment,
    setSelectedSupplyChainRiskAssessment,
    setSelectedCyberSecurityRiskAssessment,
    setTabValue,
    tabValue,
    cyberRiskAssessmentList,
    setCyberRiskAssessmentList,
    selectedRiskAssessment,
    sC_RiskAssesmentList,
    setSc_RiskAssesmentList
  } = useRiskAssessmentContext();

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelectRow = (selectedRows: any) => {
    setSelectedRiskAssessment(selectedRows);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSearchQuery("");
    setOriginalList([]);
    setTabValue(newValue);
  };

  const handleEdit = async (row: any) => {
    if (tabValue === 0) {
      let res = await fetchCyberSecurityRiskAssessmentById(row.assessmentID);
      setSelectedCyberSecurityRiskAssessment(res);
      navigate("/cyber-security-assesment-form", { state: { action: "Edit" } });
    } else {
      setSelectedSupplyChainRiskAssessment(row);
      navigate("/supply-chain-risk-assessment-form", {
        state: { action: "Edit" },
      });
    }
  };

  const handleNewRisk = () => {
    if (tabValue === 0) {
      setSelectedCyberSecurityRiskAssessment({});
      navigate("/cyber-security-assesment-form", { state: { action: "Add" } });
    } else {
      navigate("/supply-chain-risk-assessment-form", {
        state: { action: "Add" },
      });
    }
  };

  const handleMenuClick = async (menuVal: string) => {
    // console.log(" handleMenuClick menuVal", menuVal);
    if (tabValue === 0) {
      if (menuVal === "Vulnerabilities") {
        navigate("/risk-assessment-vulnerability");
      } else if (menuVal === "Threat Source") {
        navigate("/risk-assessment-threat-source");
      } else if (menuVal === "Control") {
        navigate("/risk-assessment-control");
      } else if (menuVal === "Delete") {
        handleMenuClose();
        confirmDelete();
      }
    } else {
      if (menuVal === "Download Template") {
        await handleDownload();
      } else if (menuVal === "Upload Assessment") {
        setDialogUploadFiles({ openDialog: true });
      } else if (menuVal === "Delete") {
        handleMenuClose();
        confirmDelete();
      }
    }
  };

  const handleDownload = async () => {
    try {
      const data = await downloadTemplates();
      if (data) {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Supply Chain Risk Assessment Template.xlsx"
        ); // Ensure you're saving it as a .docx file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading templates:", error);
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = event.target.value.toLowerCase();
    setSearchQuery(event.target.value);

    if (tabValue == 0) {
      const filteredRiskAssesment = originalList.filter((item) =>
        item.threatSourceName.toLowerCase().includes(searchQuery)
      );
      setCyberRiskAssessmentList(filteredRiskAssesment);
    } else {
      const filteredRiskAssesment = originalList.filter((item) =>
        item.supplierName.toLowerCase().includes(searchQuery)
      );

      setSc_RiskAssesmentList(filteredRiskAssesment);
    }
  };

  const confirmDelete = (row?: any) => {
    if (row) {
      setSelectedRiskAssessment([row]);
    }
    if (
      (row && Object.keys(row).length > 0) ||
      selectedRiskAssessment.length > 0
    ) {
      setDialogState({
        title: "Confirmation",
        body: `Are you sure you want to delete ?`,
        action: "Delete",
        actionCancel: "Cancel",
        openDeleteConfirmationDialog: true,
        openImportInfo: false,
        openSuccessDialogBox: false,
        openUploadAssessmentDialog: false,
      });
    } else {
      setDialogState({
        title: "Info",
        body: `Please select risk to delete`,
        action: "Ok",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openImportInfo: false,
        openSuccessDialogBox: true,
        openUploadAssessmentDialog: false,
      });
    }
  };

  const handleDeleteRisk = async () => {
    let res: { succeeded: any };
    if (tabValue === 0) {
      const payload = selectedRiskAssessment.map(
        (ele: { assessmentID: any }) => ele.assessmentID
      );
      res = await deleteMultipleCyberSecurityRiskAssessment(userId, payload);
    } else {
      const payload = selectedRiskAssessment.map(
        (ele: { supplierId: any }) => ele.supplierId
      );
      res = await deleteMultipleSupplyChainRiskAssessment(userId, payload);
    }

    if (res.succeeded) {
      setDialogState({
        title: "Success",
        body: "Risk successfully deleted",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openImportInfo: false,
        openSuccessDialogBox: true,
        openUploadAssessmentDialog: false,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openImportInfo: false,
        openSuccessDialogBox: true,
        openUploadAssessmentDialog: false,
      });
    }
  };

  const displayImportRisk = () => {
    handleCloseDialog();
    setOpenCsImport(true);
  };

  const handleImportCancel = () => {
    setOpenCsImport(false);
  };

  const handleCloseDialog = () => {
    if (dialogState.title === "Success") {
      if (tabValue === 0) {
        fetchCsRiskAssesment();
      } else {
        fetchScRiskAssesment();
      }
    }
    setDialogState({
      ...dialogState,
      openSuccessDialogBox: false,
      openImportInfo: false,
      openDeleteConfirmationDialog: false,
      openUploadAssessmentDialog: false,
    });
    setUploadRiskDupList([])
    setUploadRiskList([])
  };

  const handleImportRisk = () => {
    setDialogState({
      title: "Info",
      body: `Please import Control, Vulnerability and Threat Sources before importing CS Risks. If already imported, please click on Continue.`,
      action: "Continue",
      actionCancel: "Cancel",
      openDeleteConfirmationDialog: false,
      openImportInfo: true,
      openSuccessDialogBox: false,
      openUploadAssessmentDialog: false,
    });
  };

  const handleUploadFiles = (file: any) => {
    setIsLoading(true);
    setDialogUploadFiles({
      openDialog: false,
    });
    try {
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const binaryStr = e.target?.result;
          if (binaryStr) {
            // Read the workbook
            const workbook = XLSX.read(binaryStr, { type: "binary" });

            // Assuming the data is in the first sheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Convert the sheet to a 2D array of rows
            const rawSheetData: unknown[][] = XLSX.utils.sheet_to_json(
              worksheet,
              { header: 1 }
            );

            // Expected column headers
            const expectedHeaders = [
              "Supplier",
              "Supplier Product",
              "Supplier Service",
              "Does the organization rely on the listed product or service for critical processes?",
              "Does the supplier store, transmit, or access confidential organization or customer data?",
              "Supplier Risk Level",
            ];

            // Validate the header row
            const actualHeaders = rawSheetData[1] as string[]; // headers are in the second row (index 1)
            const isValidHeaders = expectedHeaders.every(
              (header, index) => header === actualHeaders[index]
            );

            if (!isValidHeaders) {
              setDialogState({
                title: "Error",

                body: "Invalid Assessment",
                action: "OK",
                actionCancel: "",
                openDeleteConfirmationDialog: false,
                openImportInfo: false,
                openSuccessDialogBox: true,
                openUploadAssessmentDialog: false,
              });
              setIsLoading(false);
              return;
            }

            // Filter and map the data after casting
            const formattedData = (rawSheetData as any[][])
              .slice(2) // Skip the header row
              .filter((row) => row && row.some((cell) => cell)) // Filter out empty rows
              .map((row) => {
                return {
                  supplierName: row[0] || "",
                  supplierProduct: row[1] || "",
                  supplierService: row[2] || "",
                  criticalProcessesDependency: row[3] || "",
                  confidentialDataAccess: row[4] || "",
                  supplierRiskLevel: row[5] || "",
                };
              });

            //  handleUploadFilesApi(formattedData);
            if (formattedData.length > 0) {
              setUploadRiskList(formattedData)
              const duplicateRisk = formattedData.filter((risk) => {
                return sC_RiskAssesmentList.some((list) => list.supplierName === risk.supplierName &&
                  list.supplierProduct === risk.supplierProduct &&
                  list.supplierService === risk.supplierService)
              })
              if (duplicateRisk.length === formattedData.length) {
                //In uploading doccument if all are duplicates
                setDialogState({
                  title: "Info",
                  body: `All assessments you are trying to upload already exist!`,
                  action: "Ok",
                  actionCancel: "",
                  openDeleteConfirmationDialog: false,
                  openImportInfo: false,
                  openSuccessDialogBox: true,
                  openUploadAssessmentDialog: false,
                });
              } else if (duplicateRisk.length > 0 && duplicateRisk.length !== formattedData.length) {
                //In uploading doccument , few are duplicates 
                setUploadRiskDupList(duplicateRisk)
                const duplicateSupplierNames = duplicateRisk.map(item => item.supplierName).join(",")
                const bodyMessage = `The following suppliers already exist: <strong>${duplicateSupplierNames}.</strong> These will be skipped during the upload, while the remaining assessments will be uploaded.`;
                setDialogState({
                  title: "Confirmation",
                  body: bodyMessage,
                  action: "Upload",
                  actionCancel: "Cancel",
                  openDeleteConfirmationDialog: false,
                  openImportInfo: false,
                  openSuccessDialogBox: false,
                  openUploadAssessmentDialog: true,
                });
              }
              else {
                handleUploadFilesApi(formattedData);

              }
            } else {
              setDialogState({
                title: "Info",
                body: `Documents cannot be uploaded if they are empty. Please ensure your document contains data before uploading.`,
                action: "Ok",
                actionCancel: "",
                openDeleteConfirmationDialog: false,
                openImportInfo: false,
                openSuccessDialogBox: true,
                openUploadAssessmentDialog: false,
              });

            }

          }
        };

        reader.readAsBinaryString(file);
      }
    } finally {
      setIsLoading(false)
    }
  };

  const uploadConfirm = () => {
    setDialogState({
      title: "",
      body: "",
      action: "",
      actionCancel: "",
      openSuccessDialogBox: false,
      openImportInfo: false,
      openDeleteConfirmationDialog: false,
      openUploadAssessmentDialog: false,
    });
    try {
      const formattedData = uploadRiskList.filter(uplodItem =>
        !uploadRiskDupList.some(dup => dup.supplierName === uplodItem.supplierName)
      )
      handleUploadFilesApi(formattedData)
    } finally {
      setUploadRiskDupList([])
      setUploadRiskList([])
    }
  }

  const handleUploadFilesApi = async (formattedData: any) => {
    setIsLoading(true)
    try {
      const date = new Date();
      const payload = formattedData.map((item: any) => ({
        ...item,
        confidentialDataAccess:
          item.confidentialDataAccess === "Yes" ? true : false,
        criticalProcessesDependency:
          item.criticalProcessesDependency === "Yes" ? true : false,
        companyProfileID: companyProfileID,
        createDate: date,
        createdBy: userId,
      }));

      const res = await createMultipleSupplyChainRiskAssessment(payload);
      if (res.succeeded) {
        setDialogState({
          title: "Success",
          body: "Risk Assessment successfully uploaded",
          action: "OK",
          actionCancel: "",
          openSuccessDialogBox: true,
          openImportInfo: false,
          openDeleteConfirmationDialog: false,
          openUploadAssessmentDialog: false,
        });
      } else {
        setDialogState({
          title: "Error",
          body: "Unexpected Error",
          action: "OK",
          actionCancel: "",
          openSuccessDialogBox: true,
          openImportInfo: false,
          openDeleteConfirmationDialog: false,
          openUploadAssessmentDialog: false,
        });
      }
    } finally {
      fetchScRiskAssesment();
      setIsLoading(false)
    }
  };

  const handledialogCloseUploadFiles = () => {
    setDialogUploadFiles({
      openDialog: false,
    });
  };

  const downloadCyberSecuritySpreadsheet = async () => {
    let res = await downloadCyberSecurityRiskAssessment(companyProfileID);
    if (res) {
      exportExcel(res);
    }
  };

  const fetchCsRiskAssesment = async () => {
    setIsLoading(true);
    const res = await fetchCyberSecurityRiskAssessmentList(companyProfileID);

    // Format the response and handle sorting with null checks
    const formattedList = res.map((plan: any) => ({
      ...plan,
      rowId: plan.assessmentID,
    })).sort((a: any, b: any) => {
      const nameA = a.threatSourceName ?? "";
      const nameB = b.threatSourceName ?? "";
      return nameA.localeCompare(nameB);
    });

    setCyberRiskAssessmentList(formattedList);
    setOriginalList(formattedList);
    setIsLoading(false);
  };


  const fetchScRiskAssesment = async () => {
    setIsLoading(true);

    const res = await fetchSupplyChainRiskAssessmentList(companyProfileID);
    const formattedList = res.map((plan: any) => ({
      ...plan,
      rowId: plan.supplierId,
      confidentialDataAccess: plan.confidentialDataAccess ? "Yes" : "No",
      criticalProcessesDependency: plan.criticalProcessesDependency
        ? "Yes"
        : "No",
    })).sort((a: supplyChainRiskAssesment, b: supplyChainRiskAssesment) => (a.supplierName ?? "").localeCompare(b.supplierName ?? ""));
    setSc_RiskAssesmentList(formattedList);
    setOriginalList(formattedList);
    setIsLoading(false);
  };

  const isDisableScMenuItems = (option: string): boolean => {
    switch (option) {
      case "Download Template":
        return !riskAssesment_SC_Access?.isDownloadTemplate;
      case "Upload Assessment":
        return !riskAssesment_SC_Access?.isUpload;
      case "Delete":
        return !riskAssesment_SC_Access?.isDelete;
      default:
        return false;
    }
  };

  useEffect(() => {
    if (tabValue === 0) {
      fetchCsRiskAssesment();
      setSc_RiskAssesmentList([]);
    } else {
      fetchScRiskAssesment();
      setCyberRiskAssessmentList([]);
    }
  }, [tabValue]);

  return (
    <Fragment>
      <Card
        sx={{
          width: "100%",
          height: "95%",
          borderRadius: "10px",
          margin: "1rem 0",
          overflow: "hidden",
        }}
      >
        <CardContent>
          <Grid container alignItems="center" justifyContent="space-between">
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="basic tabs example"
              sx={{
                ".MuiTab-root": {
                  textTransform: "none",
                  borderRadius: 1,
                  margin: 0.5,
                  padding: "2px 10px",
                  minHeight: "34px",
                  fontSize: "0.875rem",
                  "&.Mui-selected": {
                    backgroundColor: "#0066FF",
                    color: "white",
                  },
                },
                ".MuiTabs-indicator": {
                  display: "none",
                },
              }}
              TabIndicatorProps={{ sx: { display: "none" } }}
            >
              <Tab label="Cybersecurity Risk Assessment" />
              <Tab label="Supply Chain Risk Assessment" />
            </Tabs>

            <Grid container spacing={2} alignItems="center">
              {tabValue === 0 && (
                <Button
                  size="small"
                  variant="contained"
                  className="table-btn"
                  onClick={handleImportRisk}
                  disabled={!riskAssesment_CS_Access?.isImport || isLoading}
                >
                  Import
                </Button>
              )}

              <Button
                size="small"
                variant="contained"
                className="table-btn"
                onClick={handleNewRisk}

                disabled={
                  (tabValue === 0
                    ? !riskAssesment_CS_Access?.isCreate
                    : !riskAssesment_SC_Access?.isCreate) || isLoading
                }
              >
                New Risk
              </Button>

              <Button
                size="small"
                variant="contained"
                className="table-btn"
                onClick={() =>
                  tabValue === 0
                    ? downloadCyberSecuritySpreadsheet()
                    : exportExcelSupplyChain(sC_RiskAssesmentList)
                }
                disabled={
                  (cyberRiskAssessmentList.length === 0 &&
                    sC_RiskAssesmentList.length === 0) ||
                  isLoading
                }
              >
                Download Spreadsheet
              </Button>
              <TextField
                variant="outlined"
                size="small"
                placeholder={`Search ${
                  tabValue === 0 ? "Threat Source" : "Supplier Name"
                }`}
                disabled={isLoading}
                value={searchQuery}
                onChange={handleSearchChange}
              />

              <div>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  disabled={isLoading}
                  onClick={handleMenuOpen}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{ "aria-labelledby": "long-button" }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  PaperProps={{
                    style: {
                      maxHeight: 48 * 4.5,
                    },
                  }}
                >
                  {tabValue === 1
                    ? optionsTab2.map((option) => (
                        <MenuItem
                          key={option}
                          onClick={() => handleMenuClick(option)}
                          disabled={isDisableScMenuItems(option)}
                        >
                          {option}
                        </MenuItem>
                      ))
                    : optionsTab1.map((option) => (
                        <MenuItem
                          key={option}
                          onClick={() => handleMenuClick(option)}
                        disabled={
                          option === "Delete" &&
                          !riskAssesment_CS_Access?.isDelete
                        }
                        >
                          {option}
                        </MenuItem>
                      ))}
                </Menu>
              </div>
            </Grid>
          </Grid>

          <CustomTabPanel value={tabValue} index={0}>
            {isLoading ? (
              <ListItem
                sx={{ width: "100%", display: "flex", flexDirection: "column" }}
              >
                <CircularProgress />
              </ListItem>
            ) : (
              <CSDataTable
                rows={cyberRiskAssessmentList}
                columns={columns}
                multiRowSelection={true}
                previewRecord={previewRecord}
                handleSelectPreview={() => {}}
                handleSelectRow={(selectedRows) =>
                  handleSelectRow(selectedRows)
                }
                handleEdit={handleEdit}
                handleDelete={confirmDelete}
              />
            )}
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={1}>
            {isLoading ? (
              <ListItem
                sx={{ width: "100%", display: "flex", flexDirection: "column" }}
              >
                <CircularProgress />
              </ListItem>
            ) : (
              <CSDataTable
                rows={sC_RiskAssesmentList}
                columns={columns2}
                multiRowSelection={true}
                previewRecord={previewRecord}
                handleSelectPreview={() => {}}
                handleSelectRow={(selectedRows) =>
                  handleSelectRow(selectedRows)
                }
                handleEdit={handleEdit}
                handleDelete={confirmDelete}
              />
            )}
          </CustomTabPanel>
        </CardContent>
      </Card>
      {
        <DialogBoxUploadFiles
          openDialogBox={dialogUploadFiles.openDialog}
          handleFunction={handleUploadFiles}
          handleCancel={handledialogCloseUploadFiles}
        />
      }
      {
        //Import
        <CSImport
          openDialog={openCsImport}
          handleCancel={handleImportCancel}
          refreshList={() => fetchCsRiskAssesment()}
        />
      }
      {
        //Delete Confirm
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeleteRisk}
          handleCancel={handleCloseDialog}
        />
      }
      {
        //Upload Assessment Confirmation
        <DialogBoxComponent
          openDialogBox={dialogState.openUploadAssessmentDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={uploadConfirm}
          handleCancel={handleCloseDialog}
        />
      }
      {
        //Import info
        <DialogBoxComponent
          openDialogBox={dialogState.openImportInfo}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={displayImportRisk}
          handleCancel={handleCloseDialog}
        />
      }
      {
        //Success
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
